import type {Content} from '@prismicio/client'
import type {SliceComponentProps} from '@prismicio/react'
import {findLinkedButton, getResolvedLink} from 'src/common/helpers'
import type {Context} from 'src/common/types'
import {HeadingSection as DefaultHeadingSection} from './HeadingSection'

export type HeadingSectionProps = SliceComponentProps<Content.HeadingSectionSlice>

const HeadingSection = ({
  slice,
  context: {pageUid, buttonsData},
  index: componentIndex,
}: HeadingSectionProps & {context: Context}): JSX.Element | null => {
  switch (slice.variation) {
    case 'default': {
      const primaryButtonDocument = findLinkedButton(slice.primary.primary_button, buttonsData)
      const secondaryButtonDocument = findLinkedButton(slice.primary.secondary_button, buttonsData)

      return (
        <DefaultHeadingSection
          slice={slice}
          pageUid={pageUid}
          componentIndex={componentIndex}
          primaryButtonLink={getResolvedLink({link: slice.primary.primary_button, buttonsData}) ?? {link_type: 'Any'}}
          secondaryButtonLink={
            getResolvedLink({link: slice.primary.secondary_button, buttonsData}) ?? {link_type: 'Any'}
          }
          primaryButtonDocumentLabel={primaryButtonDocument?.data.label ?? ''}
          secondaryButtonDocumentLabel={secondaryButtonDocument?.data.label ?? ''}
        />
      )
    }

    default:
      return null
  }
}

export default HeadingSection
